<template>
  <div class="flex flex-col w-[75%] items-end min-h-[70px]">
    <p
      class="dark:text-[#5b4e46] rounded-[12px] bg-[#ffd489] p-4 tracking-wide leading-relaxed"
    >
      {{ item.note }}
    </p>
    <span
      class="font-semibold text-xs text-[#b0b4bb] dark:text-[#676f7d] inline-block pr-2 pt-[2px]"
      >{{ item.diff }}</span
    >
  </div>
</template>

<script>
export default {
  name: "ClientConversation",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {},
};
</script>
